import dayjs from 'dayjs';
import dayjsUTCPlugin from 'dayjs/plugin/utc';
import { endpointWrapper } from 'utils/api/meta.api';

dayjs.extend(dayjsUTCPlugin);

export const fetchSpotlights = () =>
    endpointWrapper({
        domain: 'spotlights',
        method: 'GET',
    }).then((spotlights) => {
        return Array.isArray(spotlights)
            ? spotlights.map(shapeSpotlight)
            : spotlights;
    });

export const shapeSpotlight = ({ images, link, ...restSpotlight }) => {
    const spotlight = restSpotlight;

    try {
        const url = new URL(link, location.origin);
        if (url.host.toString() === location.host.toString()) {
            spotlight.link = `${url.pathname}${url.search}${url.hash}`;
        }
    } catch (err) {
        console.error(err);
    }

    if (!spotlight.hasOwnProperty('link')) spotlight.externalLink = link;

    if (images) spotlight.images = images;

    if (spotlight.updated) {
        spotlight.updatedStr = dayjs.utc(spotlight.updated).format('MMMM YYYY');
    }

    return spotlight;
};

export const appendSpotlight = (spotlight) =>
    endpointWrapper({
        domain: spotlight.id ? `spotlights/${spotlight.id}` : 'spotlights',
        method: 'POST',
        data: spotlight,
    });
